import { Injectable } from "@angular/core"

@Injectable()
export class TrackingConfig {
  readonly production: boolean
  readonly matomoEnabled: boolean
  readonly matomoSiteID: number
}
